import { useMutation } from '@tanstack/react-query';
import { submitSessionFeedback } from '../../services/backendService';
import { SupportedLanguage } from '../../lib/i18n';

// Define the interface locally to match what's used in backendService
interface CreateSessionFeedbackParams {
  rating: number | null;
  feedbackText: string;
  consentQuote: boolean;
  language?: SupportedLanguage;
}

/**
 * Hook for submitting session feedback using TanStack Query
 * @returns Mutation object for submitting feedback
 */
export const useCreateSessionFeedback = () => {
  return useMutation({
    mutationKey: ['createSessionFeedback'],
    mutationFn: (params: CreateSessionFeedbackParams) => submitSessionFeedback(params),
    onSuccess: () => {
      // You might want to invalidate or update related queries here
      // For example, if you have a query for user feedback history:
      // queryClient.invalidateQueries({ queryKey: ['userFeedback'] });
    },
  });
};
